import React, { useCallback } from "react";
import { InputWidgetProps } from ".";

// Components
import SwitchComponent from "../../witadmin/CRUD/Common/SwitchGroup";

export function SwitchGroup(props: InputWidgetProps) {
  const handleChange = useCallback(
    ({ event }) => {
      const value =
        typeof props?.value === "number" ? (event.target.checked ? 1 : 0) : event.target.checked;
      props.onChange(value);
    },
    [props]
  );

  return (
    <SwitchComponent
      value={!!props.value}
      onChange={handleChange}
      field={{
        className: "witadmin-bs3",
      }}
      caller=""
      disabled={props.disabled || props.readonly}
      entity={{}}
    />
  );
}
